(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-releases"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializedSections = new WeakSet();

  function initPressReleaseSection(section) {
    if (!section || initializedSections.has(section)) return;
    initializedSections.add(section);

  const mobileBp = Number(section.dataset.prlMobileBp || 749);
  const disableAnimationMobile = section.dataset.prlDisableAnimationMobile === 'true';
  const animNodes = Array.from(section.querySelectorAll('[data-prl-anim-node]')).map((node) => {
    const attrs = {};
    Array.from(node.attributes).forEach((attr) => {
      if (!attr.name.startsWith('data-aos')) return;
      attrs[attr.name] = attr.value;
    });
    return { node, attrs };
  });

  function syncAosState() {
    const shouldDisable = disableAnimationMobile && window.innerWidth <= mobileBp;
    animNodes.forEach(({ node, attrs }) => {
      if (shouldDisable) {
        Object.keys(attrs).forEach((name) => node.removeAttribute(name));
      } else {
        Object.entries(attrs).forEach(([name, value]) => node.setAttribute(name, value));
      }
    });
    if (window.AOS && typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    } else if (window.AOS && typeof window.AOS.refresh === 'function') {
      window.AOS.refresh();
    }
  }

  window.addEventListener('resize', syncAosState, { passive: true });
  window.addEventListener('load', syncAosState, { passive: true });
  syncAosState();

  function cleanText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n[ \t]+/g, '\n')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function escapeHtml(value) {
    const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value || '').replace(/[&<>"']/g, (char) => map[char]);
  }

  function normalizePdfText(value) {
    return cleanText(value)
      .replace(/[“”]/g, '"')
      .replace(/[‘’]/g, "'")
      .replace(/[–—]/g, '-')
      .replace(/…/g, '...')
      .replace(/•/g, '-')
      .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
  }

  function textFromElement(element) {
    if (!element) return '';
    const paragraphTags = new Set(['ADDRESS', 'BLOCKQUOTE', 'FIGCAPTION', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P', 'TR']);
    let output = '';

    function appendBreak(count) {
      output = output.replace(/[ \t]+$/g, '');
      const match = output.match(/\n+$/);
      const current = match ? match[0].length : 0;
      if (output && current < count) output += '\n'.repeat(count - current);
    }

    function walkChildren(node, context) {
      Array.from(node.childNodes).forEach((child) => walk(child, context));
    }

    function walk(node, context = {}) {
      if (node.nodeType === Node.TEXT_NODE) {
        output += node.nodeValue;
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches('script, style, img, picture, svg, button')) return;
      if (node.tagName === 'BR') {
        output += '\n';
        return;
      }
      if (node.tagName === 'UL' || node.tagName === 'OL') {
        appendBreak(2);
        walkChildren(node, { listType: node.tagName, index: 0 });
        appendBreak(2);
        return;
      }
      if (node.tagName === 'LI') {
        appendBreak(1);
        if (context.listType === 'OL') {
          context.index += 1;
          output += `${context.index}. `;
        } else {
          output += '- ';
        }
        walkChildren(node, Object.assign({}, context, { insideListItem: true }));
        appendBreak(1);
        return;
      }
      if (paragraphTags.has(node.tagName)) {
        if (context.insideListItem) {
          walkChildren(node, context);
          return;
        }
        appendBreak(2);
        walkChildren(node, context);
        appendBreak(2);
        return;
      }
      walkChildren(node, context);
    }

    walk(element);
    return cleanText(output);
  }

  function textFromSelector(selector) {
    return textFromElement(section.querySelector(selector));
  }

  function htmlFromSelector(selector) {
    const element = section.querySelector(selector);
    if (!element) return '';
    const clone = element.cloneNode(true);
    clone.querySelectorAll('img, picture, svg, button, script, style').forEach((node) => node.remove());
    return clone.innerHTML;
  }

  function labelFromUrl(url) {
    try {
      const parsed = new URL(url, window.location.href);
      return parsed.hostname.replace(/^www\./, '') || url;
    } catch (error) {
      return url;
    }
  }

  function collectLinks() {
    const selectors = [
      '.prl__actions a[href]',
      '.prl__copy a[href]',
      '.prl__link-info a[href]',
      '.prl__contact-email[href]',
      '.prl__socials a[href]'
    ];
    const seen = new Set();
    return Array.from(section.querySelectorAll(selectors.join(','))).reduce((links, link) => {
      const href = link.href || link.getAttribute('href') || '';
      if (!href || href === '#' || href.toLowerCase().startsWith('javascript:')) return links;
      const key = href.toLowerCase();
      if (seen.has(key)) return links;
      seen.add(key);
      links.push({
        label: cleanText(link.textContent) || link.getAttribute('aria-label') || labelFromUrl(href),
        url: href
      });
      return links;
    }, []);
  }

  function collectReleaseData() {
    const entry = section.querySelector('[data-prl-entry]');
    const linkInfoElements = Array.from(section.querySelectorAll('.prl__link-info'));
    return {
      dateFile: entry ? entry.getAttribute('data-prl-release-date-file') || 'undated' : 'undated',
      published: textFromSelector('.prl__published'),
      headerHtml: htmlFromSelector('.prl__header'),
      headerText: textFromSelector('.prl__header'),
      contactLabel: textFromSelector('.prl__contact-label'),
      contactName: textFromSelector('.prl__contact-name'),
      contactEmail: textFromSelector('.prl__contact-email'),
      contactDetails: textFromSelector('.prl__contact-details'),
      embargo: textFromSelector('.prl__embargo'),
      headline: textFromSelector('.prl__headline'),
      subheading: textFromSelector('.prl__subheading'),
      copyHtml: htmlFromSelector('.prl__copy'),
      copyText: textFromSelector('.prl__copy'),
      linkInfoHtml: linkInfoElements.map((element) => {
        const clone = element.cloneNode(true);
        clone.querySelectorAll('img, picture, svg, button, script, style').forEach((node) => node.remove());
        return clone.innerHTML;
      }).filter(Boolean).join(''),
      linkInfoText: cleanText(linkInfoElements.map(textFromElement).filter(Boolean).join('\n\n')),
      links: collectLinks()
    };
  }

  function buildPrintHtml(data) {
    const linkItems = data.links.map((link) => (
      `<li><strong>${escapeHtml(link.label)}</strong><br><span>${escapeHtml(link.url)}</span></li>`
    )).join('');

    return `<!doctype html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>${escapeHtml(data.headline || 'Press Release')}</title>
          <style>
            body { margin: 0; padding: 48px; color: #111; font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5; }
            main { max-width: 760px; margin: 0 auto; }
            h1 { margin: 24px 0 8px; font-size: 24pt; line-height: 1.1; }
            h2 { margin: 28px 0 8px; font-size: 11pt; letter-spacing: .08em; text-transform: uppercase; }
            p { margin: 0 0 12px; }
            .meta { margin: 0 0 24px; font-size: 9pt; text-transform: uppercase; }
            .subheading { margin: 0 0 24px; font-size: 15pt; }
            .contact { margin: 24px 0; font-size: 10pt; }
            .contact p { margin-bottom: 4px; }
            ul { margin: 8px 0 0; padding: 0; list-style: none; }
            li { margin: 0 0 12px; overflow-wrap: anywhere; }
            @page { margin: .6in; }
          <\/style>
        </head>
        <body>
          <main>
            ${data.published ? `<p class="meta">${escapeHtml(data.published)}</p>` : ''}
            ${data.headerHtml ? `<section>${data.headerHtml}</section>` : ''}
            ${data.contactName || data.contactEmail || data.contactDetails || data.embargo ? `
              <section class="contact">
                <h2>${escapeHtml(data.contactLabel || 'CONTACT INFO')}</h2>
                ${data.contactName ? `<p><strong>${escapeHtml(data.contactName)}</strong></p>` : ''}
                ${data.contactEmail ? `<p>${escapeHtml(data.contactEmail)}</p>` : ''}
                ${data.contactDetails ? `<p>${escapeHtml(data.contactDetails).replace(/\n/g, '<br>')}</p>` : ''}
                ${data.embargo ? `<p>${escapeHtml(data.embargo)}</p>` : ''}
              </section>
            ` : ''}
            ${data.headline ? `<h1>${escapeHtml(data.headline)}</h1>` : ''}
            ${data.subheading ? `<p class="subheading">${escapeHtml(data.subheading)}</p>` : ''}
            ${data.copyHtml ? `<section>${data.copyHtml}</section>` : ''}
            ${data.linkInfoHtml ? `<section>${data.linkInfoHtml}</section>` : ''}
            ${linkItems ? `<section><h2>Links</h2><ul>${linkItems}</ul></section>` : ''}
          </main>
        </body>
      </html>`;
  }

  function printRelease() {
    const data = collectReleaseData();
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    printWindow.document.open();
    printWindow.document.write(buildPrintHtml(data));
    printWindow.document.close();
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 250);
  }

  function wrapText(text, maxChars) {
    const words = normalizePdfText(text).split(/\s+/).filter(Boolean);
    const lines = [];
    let line = '';
    words.forEach((word) => {
      const next = line ? `${line} ${word}` : word;
      if (next.length > maxChars && line) {
        lines.push(line);
        line = word;
      } else {
        line = next;
      }
    });
    if (line) lines.push(line);
    return lines;
  }

  function addPdfText(items, text, size, font, gapAfter, options = {}) {
    const paragraphGap = typeof options.paragraphGap === 'number' ? options.paragraphGap : Math.max(6, size * 0.65);
    const lineGap = typeof options.lineGap === 'number' ? options.lineGap : 0;
    const parts = normalizePdfText(text).split(/\n{2,}/).map((part) => part.trim()).filter(Boolean);
    parts.forEach((part, partIndex) => {
      const hardLines = part.split(/\n/).map((line) => line.trim()).filter(Boolean);
      hardLines.forEach((hardLine, hardLineIndex) => {
        const maxChars = Math.max(24, Math.floor(504 / (size * 0.52)));
        const wrapped = wrapText(hardLine, maxChars);
        wrapped.forEach((line, lineIndex) => {
          const isLastWrappedLine = lineIndex === wrapped.length - 1;
          const isLastHardLine = hardLineIndex === hardLines.length - 1;
          const isLastPart = partIndex === parts.length - 1;
          const isLastLine = isLastPart && isLastHardLine && isLastWrappedLine;
          const isParagraphEnd = isLastHardLine && isLastWrappedLine;
          const isHardLineEnd = isLastWrappedLine;
          items.push({
            text: line,
            size,
            font,
            gapAfter: isLastLine ? gapAfter : isParagraphEnd ? paragraphGap : isHardLineEnd ? lineGap : 0
          });
        });
      });
    });
  }

  function buildPdfItems(data) {
    const items = [];
    addPdfText(items, data.published, 9, 'F1', 10);
    addPdfText(items, data.headerText, 11, 'F1', 12);
    if (data.contactName || data.contactEmail || data.contactDetails || data.embargo) {
      addPdfText(items, data.contactLabel || 'CONTACT INFO', 10, 'F2', 5);
      addPdfText(items, data.contactName, 10, 'F2', 2);
      addPdfText(items, data.contactEmail, 10, 'F1', 2);
      addPdfText(items, data.contactDetails, 10, 'F1', 2);
      addPdfText(items, data.embargo, 10, 'F1', 14);
    }
    addPdfText(items, data.headline, 18, 'F2', 8);
    addPdfText(items, data.subheading, 13, 'F1', 12);
    addPdfText(items, data.copyText, 11, 'F1', 14);
    addPdfText(items, data.linkInfoText, 10, 'F1', 12);
    if (data.links.length) {
      addPdfText(items, 'Links', 12, 'F2', 6);
      data.links.forEach((link) => {
        addPdfText(items, link.label, 10, 'F2', 1);
        addPdfText(items, link.url, 9, 'F1', 8);
      });
    }
    return items;
  }

  function pdfEscape(value) {
    return normalizePdfText(value).replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
  }

  function makePdf(items) {
    const pageWidth = 612;
    const pageHeight = 792;
    const margin = 54;
    const pages = [];
    let page = [];
    let y = pageHeight - margin;

    items.forEach((item) => {
      const lineHeight = Math.max(item.size * 1.35, 12);
      if (y - lineHeight < margin) {
        pages.push(page);
        page = [];
        y = pageHeight - margin;
      }
      page.push({ text: item.text, size: item.size, font: item.font, x: margin, y });
      y -= lineHeight + (item.gapAfter || 0);
    });
    if (page.length) pages.push(page);

    const objects = [
      '<< /Type /Catalog /Pages 2 0 R >>',
      '',
      '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>',
      '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>'
    ];
    const kids = [];
    pages.forEach((pageLines) => {
      const pageId = objects.length + 1;
      const contentId = pageId + 1;
      kids.push(`${pageId} 0 R`);
      const stream = pageLines.map((line) => (
        `BT /${line.font} ${line.size} Tf ${line.x.toFixed(2)} ${line.y.toFixed(2)} Td (${pdfEscape(line.text)}) Tj ET`
      )).join('\n');
      objects.push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth} ${pageHeight}] /Resources << /Font << /F1 3 0 R /F2 4 0 R >> >> /Contents ${contentId} 0 R >>`);
      objects.push(`<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`);
    });
    objects[1] = `<< /Type /Pages /Kids [${kids.join(' ')}] /Count ${pages.length} >>`;

    let pdf = '%PDF-1.4\n';
    const offsets = [0];
    objects.forEach((object, index) => {
      offsets.push(pdf.length);
      pdf += `${index + 1} 0 obj\n${object}\nendobj\n`;
    });
    const xrefOffset = pdf.length;
    pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
    offsets.slice(1).forEach((offset) => {
      pdf += `${String(offset).padStart(10, '0')} 00000 n \n`;
    });
    pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`;
    return new Blob([pdf], { type: 'application/pdf' });
  }

  function buildPdfFileName(data) {
    const headlineWords = (data.headline.match(/[A-Za-z0-9]+/g) || ['press', 'release']).slice(0, 4);
    const headlinePart = headlineWords.join('_').toUpperCase();
    const datePart = String(data.dateFile || 'undated').replace(/[^A-Za-z0-9-]+/g, '_').toUpperCase();
    return `${headlinePart}_PRESS_RELEASE_${datePart}.pdf`;
  }

  function downloadPdf() {
    const data = collectReleaseData();
    const items = buildPdfItems(data);
    if (!items.length) addPdfText(items, data.headline || 'Press Release', 12, 'F1', 0);
    const blob = makePdf(items);
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = buildPdfFileName(data);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  const printButton = section.querySelector('[data-prl-print]');
  const pdfButtons = section.querySelectorAll('[data-prl-pdf]');
  if (printButton) printButton.addEventListener('click', printRelease);
  pdfButtons.forEach((pdfButton) => {
    pdfButton.addEventListener('click', downloadPdf);
  });

  }

  function initPressReleaseSections(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-prl-root]').forEach(initPressReleaseSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPressReleaseSections(document), { once: true });
  } else {
    initPressReleaseSections(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPressReleaseSections(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
